const merge = require('lodash/merge')

const config = {
  all: {
    env: process.env.NODE_ENV || 'development',
    isDev: process.env.NODE_ENV !== 'production',
    basename: process.env.PUBLIC_URL,
    isBrowser: typeof window !== 'undefined',
  },
  test: {},
  development: {
    apiUrl:
      window.RUNTIME_CONFIG?.REACT_APP_API_URL || process.env.REACT_APP_API_URL,
    oauth: {
      clientId:
        window.RUNTIME_CONFIG?.REACT_APP_OAUTH_CLIENT_ID ||
        process.env.REACT_APP_OAUTH_CLIENT_ID,
      clientSecret:
        window.RUNTIME_CONFIG?.REACT_APP_OAUTH_CLIENT_SECRET ||
        process.env.REACT_APP_OAUTH_CLIENT_SECRET,
    },
  },
  production: {
    apiUrl:
      window.RUNTIME_CONFIG?.REACT_APP_API_URL || process.env.REACT_APP_API_URL,
    oauth: {
      clientId:
        window.RUNTIME_CONFIG?.REACT_APP_OAUTH_CLIENT_ID ||
        process.env.REACT_APP_OAUTH_CLIENT_ID,
      clientSecret:
        window.RUNTIME_CONFIG?.REACT_APP_OAUTH_CLIENT_SECRET ||
        process.env.REACT_APP_OAUTH_CLIENT_SECRET,
    },
  },
}

module.exports = merge(config.all, config[config.all.env])
